export default {
    title: 'New Authorization',
    type: 'Authorization type',
    typeSubtitle: 'Select an authorization type to continue:',
    footerTitle: 'Select an authorization type to continue:',
    backBtn: 'Cancel',
    continueBtn: 'Continue',
    medicalTypes : {
        subHeader: 'MEDICAL',
        medicines: 'Medicines',
        diagnostic: 'Diagnoses',
        laboratories: 'Laboratories',
        outpatientCare: 'Outpatient care',
        process: 'Medical Process',
        generic: 'Generic'
    },
    navBar: {
        medicines: '(Medicines)',
        diagnostic: '(Diagnoses)',
        laboratories: '(Laboratories)',
        outpatientCare: '(Outpatient care)',
        process: '(Medical Process)'
    }
}